

import { useEffect, useState } from 'react';
import MiniMasonry from "minimasonry";
import { getNumber } from '../../functions';

const Masonry = ({ attributes, filteredItems, mixAllData, clientId, EImage, dummyImage, ButtonContent, EAudio, EVideo, galleryIcon, setOpen, setActiveIndex, isOpen, custom, isBackend, activeIndex, ContentArea, Modal }) => {
    const { lightboxType, cId, layout, columnGap, rowGap } = attributes;

    const [miniMasonry, setMiniMasonry] = useState(null);
    let masonryEl = document.querySelector(`#lbbLightBox-${cId} .lbbLightBox`);

    useEffect(() => {
        if (!window.location.href.includes('wp-admin')) {
            masonryEl = document.querySelector(`#lbbLightBox-${cId} .lbbLightBox`);

        }
        if (masonryEl) {
            const masonryObj = new MiniMasonry({
                container: masonryEl,
                gutterX: getNumber(columnGap),
                gutterY: getNumber(rowGap),
                minify: false,
                ultimateGutter: 5,
                surroundingGutter: true
            });
            setMiniMasonry(masonryObj);
        } else {
            miniMasonry?.destroy();
            document.querySelector(`#lbbLightBox-${cId} .lbbLightBox`).style.height = 'auto';
        }
    }, [layout, masonryEl, columnGap, rowGap, filteredItems?.length]);

    return filteredItems?.map((item, index) => {
        const { type, thumbnail, content, caption } = item || {};

        return <div key={index} className="flex flex-wrap gap-5 justify-center max-w-5xl mx-auto px-6 lbbContent_area">
            {'image' === type && <a data-fancybox={`${mixAllData ? `allDataGallery-${clientId}` : `gallery-${clientId}`}`} data-caption={caption} className="lbbmodalbtn" href={`${content === '' ? EImage : content}`} >
                {"gallery" === lightboxType ? <>
                    <img className="rounded" src={content || dummyImage} />
                </>
                    : <button><ButtonContent /></button>
                }

            </a>}

            {'audio' === type && <a data-fancybox={`${mixAllData ? `allDataGallery-${clientId}` : `audio-gallery-${clientId}`}`} data-caption={caption} className="lbbmodalbtn" href={`${content === '' ? EAudio : content}`} data-type={`${content === '' ? '' : 'html5video'}`}>
                {"gallery" === lightboxType ? <>
                    <img className="rounded" src={thumbnail || dummyImage} />
                    {galleryIcon &&
                        <div className="music_icon audio_icon">
                            <i className="fas fa-music"></i>
                        </div>
                    }
                </>
                    : <button><ButtonContent /></button>
                }
            </a>
            }

            {
                ('video' === type && content.split('.')[1] !== 'cloudflarestream') ? <a data-fancybox={`${mixAllData ? `allDataGallery-${clientId}` : `video-gallery-${clientId}`}`} data-caption={caption} className="lbbmodalbtn" href={`${content === '' ? EVideo : content}`} data-type={`${content === '' ? '' : 'html5video'}`}>
                    {"gallery" === lightboxType ? <>
                        <img className="rounded" src={thumbnail || dummyImage} />
                        {galleryIcon &&
                            <div className="music_icon video_icon">
                                <i className="fas fa-play"></i>
                            </div>
                        }
                    </>
                        : <button><ButtonContent /></button>
                    }
                </a> :
                    ('video' === type && content.split('.')[1] === 'cloudflarestream') && <>

                        <div id={`dialog-content-${clientId}${index}`} className='iframeHidden'>
                            <div className="feedPopUpArea">
                                <div className="feedPopUp">
                                    <iframe src={content} className='iframe' />
                                </div>
                            </div>
                        </div>

                        <a data-fancybox={`${mixAllData ? `allDataGallery-${clientId}` : `video-gallery-${clientId}`}`} data-src={`#dialog-content-${clientId}${index}`} data-caption={caption} className="feedItem">
                            {"gallery" === lightboxType ? <>
                                <img className="rounded" src={thumbnail || dummyImage} />
                                {galleryIcon &&
                                    <div className="music_icon video_icon">
                                        <i className="fas fa-play"></i>
                                    </div>
                                }
                            </>
                                : <button><ButtonContent /></button>
                            }
                        </a>
                    </>
            }

            {
                'content' === type && <a>
                    {"gallery" === lightboxType ?
                        <div className="content-thumbnail">
                            <img src={thumbnail || dummyImage} onClick={() => { setOpen(true); setActiveIndex(index); }} />
                            {galleryIcon &&
                                <div className="contnet-svgImage">
                                    <i className="fas fa-newspaper"></i>
                                </div>
                            }
                        </div>
                        : <button onClick={() => { setOpen(true); setActiveIndex(index); }}><ButtonContent /></button>
                    }

                    {isOpen && activeIndex === index && <Modal clientId={clientId} activeIndex={activeIndex} onRequestClose={() => setOpen(false)} className="lbbLightBoxModal" overlayClassName='lbbLightBoxModalOverlay' shouldCloseOnClickOutside={false}>
                        <ContentArea clientId={clientId} item={item} index={activeIndex} isBackend={isBackend} wp={wp} custom={custom} />
                    </Modal>}
                </a>
            }

            {/* new code start  */}
            {/* {
                <a data-fancybox={`${mixAllData ? `allDataGallery-${clientId}` : `pdf-gallery-${clientId}`}`} data-src={`#dialog-content-${clientId}${index}`} data-caption={caption} className="feedItem">
                    {"gallery" === lightboxType ? <>
                        <img className="rounded" src={thumbnail || dummyImage} />
                        {galleryIcon &&
                            <div className="music_icon video_icon">
                                <i className="fas fa-play"></i>
                            </div>
                        }
                    </>
                        : <button><ButtonContent /></button>
                    }
                </a>
            } */}
        </div>
    })
}
export default Masonry;